var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.appointments)?_c('FullCalendar',{attrs:{"options":_vm.calendarOptions}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }